import React from 'react';
export var SpeechBubble = function (_a) {
    var color = _a.color, _b = _a.height, height = _b === void 0 ? '1em' : _b, _c = _a.width, width = _c === void 0 ? '1em' : _c;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 24 22", color: color, fill: "none" },
        React.createElement("path", { d: "M11.864 0C5.322 0 0 4.384 0 9.774a8.872 8.872 0 0 0 3.275 6.747L.903 21.253a.516.516 0 0 0 .68.698L7.926 19c1.28.367 2.606.553 3.938.55 6.541 0 11.864-4.385 11.864-9.775C23.728 4.384 18.405 0 11.864 0Z", fill: "currentColor" })));
};
